export default __webpack_public_path__ + "media/images/temporary/mud-run-3-641270709c7a95960bdac29e37012630.jpg";